import ContentTitle from './src/content-title';

export default ContentTitle;
